module.exports = __webpack_public_path__ + "/static/images/fs_logo.df5bed988ebaec2cb3b77303145f913d.png";


//////////////////
// WEBPACK FOOTER
// ./images/fs_logo.png
// module id = 3USj
// module chunks = 0